export class LetterFilters {

    /**
     * Converts a string to sentence case
     *
     * @param value
     */
    static sentenceCase (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }

    /**
     * Converts a string to title case
     *
     * @param value
     * @returns {string}
     */
    static titleCase (value) {
        return value.replace(/\w\S*/g, (v) => v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());
    }

    /**
     * Converts a string to upper case
     *
     * @param value
     */
    static upperCase (value) {
        return value.toUpperCase();
    }

    /**
     * Converts a string to lower case
     *
     * @param value
     * @returns {string}
     */
    static lowerCase (value) {
        return value.toLowerCase();
    }

}



// WEBPACK FOOTER //
// ./src/filters/letter-filters.js